import $ from 'jquery';

function onDocumentReady() {
	$('.accordion-item').on('click', '.toggle', onClickToggleAccordionItem);
	$('.accordion.limit-open-items').on('toggle', '.accordion-item', onAccordionItemToggle);
}

function onAccordionItemToggle(e, item) {
	const accordion = $(item).closest('.accordion');

	accordion.find('.accordion-item.open').not(item)
		.removeClass('open')
		.find('.content').slideUp();

}

function onClickToggleAccordionItem(e) {
	const item = $(e.currentTarget).closest('.accordion-item');
	const content = item.find('.content');

	item.trigger('toggle', item);

	item.toggleClass('open');
	if (item.hasClass('open')) {
		content.slideDown();
	} else {
		content.slideUp();
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
